// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-comment-tooltip {
  min-width: 200px;
}
.job-comment-tooltip .job-comment-tooltip-item {
  width: 100%;
}
.job-comment-tooltip .job-comment-tooltip-item .channel-name {
  flex: 2;
}
.job-comment-tooltip .job-comment-tooltip-item .channel-value {
  flex: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/job/components/comment-log-tooltip/comment-log-tooltip.component.scss"],"names":[],"mappings":"AAAA;EACC,gBAAA;AACD;AACC;EACC,WAAA;AACF;AACE;EACC,OAAA;AACH;AAEE;EACC,SAAA;AAAH","sourcesContent":[".job-comment-tooltip {\n\tmin-width: 200px;\n\n\t.job-comment-tooltip-item {\n\t\twidth: 100%;\n\n\t\t.channel-name {\n\t\t\tflex: 2;\n\t\t}\n\n\t\t.channel-value {\n\t\t\tflex: 1.5;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
